import { StyleSheet, Platform } from "react-native";
export default StyleSheet.create({
  textInput: {
    flex: 1,
    paddingLeft: 10,
    paddingTop: 10,
    fontSize: 16,
    lineHeight: 16,
    marginTop: Platform.select({
      ios: 15,
      android: 0
    }),
    marginBottom: Platform.select({
      ios: 15,
      android: 3
    })
  }
});